import React, { createContext, useState, useEffect, useContext } from 'react';
import { translations, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../locales';
import api from '../services/api';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(DEFAULT_LANGUAGE);
  const [loading, setLoading] = useState(true);

  // Carregar idioma ao iniciar
  useEffect(() => {
    loadLanguage();
  }, []);

  const loadLanguage = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }

      // 1. Tentar pegar do perfil do usuário
      const profileRes = await api.get('/api/profile/me');
      const userLanguage = profileRes.data.user?.language;
      
      if (userLanguage && translations[userLanguage]) {
        setLanguageState(userLanguage);
        setLoading(false);
        return;
      }

      // 2. Se não tiver, tentar pegar do tenant
      try {
        const tenantRes = await api.get('/api/profile/tenant-language');
        const tenantLanguage = tenantRes.data?.language;
        
        if (tenantLanguage && translations[tenantLanguage]) {
          setLanguageState(tenantLanguage);
          setLoading(false);
          return;
        }
      } catch (err) {
        console.warn('Não foi possível carregar idioma do tenant');
      }

      // 3. Fallback para padrão
      setLanguageState(DEFAULT_LANGUAGE);
    } catch (err) {
      console.error('Erro ao carregar idioma:', err);
      setLanguageState(DEFAULT_LANGUAGE);
    } finally {
      setLoading(false);
    }
  };

  const setLanguage = async (newLanguage) => {
    try {
      // Salvar no backend
      await api.put('/api/profile/me', { language: newLanguage });
      
      // Atualizar estado local
      setLanguageState(newLanguage);
      
      return true;
    } catch (err) {
      console.error('Erro ao alterar idioma:', err);
      return false;
    }
  };

  // Função de tradução
  const t = (key, params = {}) => {
    const translation = translations[language]?.[key] || translations[DEFAULT_LANGUAGE]?.[key] || key;
    
    // Substituir parâmetros
    let result = translation;
    Object.keys(params).forEach(paramKey => {
      result = result.replace(`{${paramKey}}`, params[paramKey]);
    });
    
    return result;
  };

  const value = {
    language,
    setLanguage,
    t,
    loading,
    supportedLanguages: SUPPORTED_LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage deve ser usado dentro de LanguageProvider');
  }
  return context;
};

export default LanguageContext;